<web-header [mobile]="true"></web-header>

<ion-content>

    <ion-item lines="none" class="common-card" color="primary" *ngIf='buyMembershipWallet'
        (click)="buyAnotherMembership($event)">
        <ion-label class="ion-text-wrap" *ngIf="availableMembership">{{'cardWallet.buyAnotherMembership' |
            translate:brandName}}
        </ion-label>
        <ion-label class="ion-text-wrap" *ngIf="!availableMembership">
            {{'membership_home.visitor_card' | translate:brandName}}
        </ion-label>
        <ion-icon slot="end" class="ca-right-arrow-icon"></ion-icon>
    </ion-item>

    <ion-item-group [hidden]="skeleton">
        <ion-radio-group [(ngModel)]="membershipNumber" (ionChange)="changeMembershipCard($event)">
            <div class="membershipCard-item"
                *ngFor="let item of walletData; let i = index; trackBy: trackByMembershipNumber">
                <ion-radio [value]="item?.membershipNumber" [id]="item?.membershipNumber" class="membership-radio"
                    mode="ios"></ion-radio>
                <!-- Membership Card Start -->
                <app-membership-card [walletCard]="true" [showUserImg]="showUserImg" [cardImage]="item?.cardImage"
                    [cardData]="{memberFirstName: item?.firstName, memberLastName: item?.lastName, level: item?.membershipType, validThruShow: item?.validThroughshow, startFrom: item.startFrom}"
                    [membershipNumber]="item?.membershipNumber" [cardType]="item.cardType" [diffDays]="diffDays"
                    [staticContent]="staticContent" [expiryProgress]="item.expiryProgress" [logo]="item?.propertyLogo">
                </app-membership-card>
                <!-- Membership Card End -->
                <ion-button *ngIf="item.giftText || item.giftVideo" mode="ios" [hidden]="!item.isMembershipGifted"
                    class="gift-btn" color="primary" (click)="openModalViewGiftMembership(item)" expand="block">
                    {{'cardWallet.membershipViewGiftMessage' | translate}}
                </ion-button>
                <ion-button *ngIf="!item.giftText && !item.giftVideo && item.isMembershipGifted" mode="ios"
                    [hidden]="!item.isMembershipGifted" class="gift-btn" color="primary"
                    (click)="openModalViewGiftMembership(item)" expand="block">
                    {{'cardWallet.membershipGiftReceived' | translate}}
                </ion-button>
            </div>
        </ion-radio-group>

        <ion-item class="btn-item" (click)="walletAddWeb()" lines="none">
            <ion-buttons class="btnGroupsadd" *ngIf="showWallet">
                <ion-button color="primary" class="newButtonadd">{{'tableReserve.wallet' | translate}}</ion-button>
            </ion-buttons>
            <div *ngIf="!showWallet" class="googleWallet">
                <img src="assets/icon/google-wallet-icon.svg" />
                <!-- <span>Add to Google Wallet</span> -->
              </div>
        </ion-item>
    </ion-item-group>

    <!-- Skeleton -->
    <ion-item-group [hidden]="!skeleton">
        <div class="benefitsSkelton">
            <!-- <ion-card class="common-card">
                <ion-skeleton-text style="height: 50px; margin: 0px;"></ion-skeleton-text>
            </ion-card> -->
            <ion-card class="common-card">
                <ion-skeleton-text style="height: 20vh; margin: 0px;"></ion-skeleton-text>
            </ion-card>
            <ion-card class="common-card">
                <ion-skeleton-text style="height: 20vh; margin: 0px;"></ion-skeleton-text>
            </ion-card>
            <ion-card class="common-card">
                <ion-skeleton-text style="height: 20vh; margin: 0px;"></ion-skeleton-text>
            </ion-card>
            <ion-card class="common-card">
                <ion-skeleton-text style="height: 20vh; margin: 0px;"></ion-skeleton-text>
            </ion-card>
            <ion-card class="common-card">
                <ion-skeleton-text style="height: 20vh; margin: 0px;"></ion-skeleton-text>
            </ion-card>
        </div>
    </ion-item-group>

</ion-content>

<ion-footer>
    <ion-button expand="block" mode="ios" class="btn-default dark-gradient" (click)="navToMembership($event)">
        {{'cardWallet.update' | translate}}</ion-button>
</ion-footer>